import { Component } from 'react';
import PropTypes from 'prop-types';

class ExternalRedirect extends Component {
  componentDidMount() {
    const { to } = this.props;

    if (process.browser) {
      global.location = to;
    }
  }

  render() {
    const { to } = this.props;

    if (process.browser) {
      return null;
    }

    return (
      <div>
        If your browser does not redirect you automatically please click{' '}
        <a href={to}>here</a>
      </div>
    );
  }
}

ExternalRedirect.propTypes = {
  to: PropTypes.string.isRequired,
};

export default ExternalRedirect;
